/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Is_PublishedInputs */

const cs_order_is_published = /** @type {(inputs: Order_Is_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikováno`)
};

const en_order_is_published = /** @type {(inputs: Order_Is_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Order_Is_PublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_is_published = /** @type {((inputs?: Order_Is_PublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Is_PublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_is_published(inputs)
	return cs_order_is_published(inputs)
});